import React from 'react';
import { AGENT_RENDERERS } from './AgentRenderers';

interface ResponseRendererProps {
  agentType: string;
  data: any;
}

const ResponseRenderer: React.FC<ResponseRendererProps> = ({ agentType, data }) => {
  const Renderer = AGENT_RENDERERS[agentType as keyof typeof AGENT_RENDERERS];

  if (!Renderer) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <div className="text-sm text-red-600">
          Unknown agent type: {agentType}
        </div>
        <div className="text-xs text-red-400 mt-1">
          Raw data: {JSON.stringify(data, null, 2).substring(0, 200)}...
        </div>
      </div>
    );
  }

  return <Renderer data={data} />;
};

export default ResponseRenderer;